import * as dbh_lib from "./dbh_lib";
import { dbh_loading } from "./dbh_loading";
import { dbh_helper } from "./dbh_helper";

export class dbh_ajax {
    sendGetRequest(getRequest: getRequest) {
        dbh_helper.BeginSubmitHandler();

        $.ajax({
            type: "GET",
            url: this.getUrlFromRequest(getRequest).url,
            dataType: "json",
            complete: function (response: object) {
                const dbhStatus = (response as any).getResponseHeader("dbh-status");
                if (dbhStatus) {
                    if (dbhStatus === '401') {
                        window.open(`/FehlendeBerechtigung`, "_self");
                    }
                    else if (dbhStatus === '404') {
                        window.open(`/404Fehler`, "_self");
                    }
                    else if (dbhStatus === '500') {
                        window.open(`/FehlerServer`, "_self");
                    }
                    else {
                        window.open(`/FehlerAllgemein`, "_self");
                    }
                    return;
                }

                getRequest.callbackSuccess?.(response);

                // ohne Timeout funktionieren Eventzuweisungen in Chrome nicht
                window.setTimeout(() => {
                    dbh_helper.setDefaultFormValues();
                }, 100);

                dbh_helper.EndSubmitHandler();
            },
            error: function (response: object) {
                console.log(response);
                getRequest.callbackError?.(response);
                dbh_helper.EndSubmitHandler();
            }
        });
    }

    sendPostRequest(postRequest: postRequest) {
        dbh_helper.BeginSubmitHandler();
        let dataExtended = postRequest.parameter;

        if (postRequest.csrfToken) {
            // Wenn FormData, füge Token hinzu
            if (dataExtended instanceof FormData) {
                dataExtended.append('__RequestVerificationToken', postRequest.csrfToken);
            } else {
                $.extend(true, dataExtended, { __RequestVerificationToken: postRequest.csrfToken });
            }
        }

        // Prüfen auf string[][] - für POST muss es in ein Objekt umgewandelt werden
        // ACHTUNG - Code erstmal auskommentiert, da andernfalls Nebeneffekte auftreten können, wenn die Daten nicht in der Form vorliegen -> Kodierung von Freitextfeldern bspw. würden nicht wie erwartet funktionieren

        //if (Array.isArray(dataExtended) &&
        //    dataExtended.every(e => Array.isArray(e) && e.length === 2 && typeof e[0] === "string")) {

        //    const converted: { [key: string]: string } = {};
        //    for (const [key, value] of dataExtended) {
        //        converted[key] = value;
        //    }
        //    dataExtended = converted;
        //    postRequest.parameter = converted;
        //}

        var loading: dbh_loading = new dbh_loading();
        if (postRequest.loadingTarget) {
            loading.onLoading(postRequest.loadingTarget);
        }

        $.ajax({
            type: "POST",
            url: this.getUrlFromRequest(postRequest).url,
            data: dataExtended,
            processData: postRequest.processData,
            contentType: postRequest.contentType,            
            xhrFields: {
                responseType: postRequest.responseType
            },
            success: function (result: object, textStatus: string, jqXHR: object) {
                if (postRequest.loadingTarget) {
                    loading.onLoadingFinished();
                }

                postRequest.callbackSuccess?.(result);

                // ohne Timeout funktionieren Eventzuweisungen in Chrome nicht
                window.setTimeout(() => {
                    dbh_helper.setDefaultFormValues();
                }, 100);

                dbh_helper.EndSubmitHandler();
            },
            error: function (result: object) {
                if (postRequest.loadingTarget) {
                    loading.onLoadingFinished();
                }
                postRequest.callbackError?.(result);
                dbh_helper.EndSubmitHandler();
            }
        });
    }

    private getUrlFromRequest(r: getRequest | postRequest): { url: string } {
        if (Array.isArray(r.parameter)) {
            let params = Array<string>();
            for (var i = 0, l = r.parameter.length; i < l; i++) {
                params.push(r.parameter[i].join("="));
            }
            return { url: dbh_lib.konstanten.BASE_URL + "/" + (r.controllerName ? r.controllerName + "/" : "") + r.actionName + "?" + params.join("&") };
        }
        else {
            return { url: dbh_lib.konstanten.BASE_URL + "/" + (r.controllerName ? r.controllerName + "/" : "") + r.actionName };
        }
    }

    getPostParameterString(order, page, pageSize, viewSwitchState, where?): string {
        var parameterString: string;
        parameterString = "order=" + order + "&";
        parameterString = parameterString + "page=" + page + "&";
        parameterString = parameterString + "pageSize=" + pageSize + "&";
        parameterString = parameterString + "viewSwitchState=" + viewSwitchState + "&";
        if (where) {
            parameterString = parameterString + "whereKey=" + where + "&";
        }

        return parameterString;
    }

    getPostParameterStringWithForm(form, order, page, pageSize, viewSwitchState?, where?): string {
        var parameterString: string;
        if (form != null && form != undefined) {
            parameterString = $(form).serialize();
        }
        if (parameterString.length > 0) {
            parameterString = parameterString + "&";
        }
        parameterString = parameterString + this.getPostParameterString(order, page, pageSize, viewSwitchState, where);

        return parameterString;
    }

    getPostParameterStringForForm(form): string {
        var parameterString: string;
        if (form != null && form != undefined) {
            parameterString = $(form).serialize();
        }
        return parameterString;
    }

    getGetParameterArrayForForm(form): any {
        let parameterString: string;
        const parameterArray = [];
        parameterString = this.getPostParameterStringForForm(form);

        const etSplit = parameterString.split("&");

        if (etSplit.length > 0) {
            for (let i = 0; i < etSplit.length; i++) {
                parameterArray.push(etSplit[i].split("="));
            }
        }
        return parameterArray;
    }
}

export interface getRequest {
    controllerName: string;
    actionName: string;
    parameter?: string[][];
    callbackSuccess?: dbh_lib.CallbackFunctions;
    callbackError?: dbh_lib.CallbackFunctions;
}

export interface postRequest {
    //areaName?: string;
    controllerName: string;
    actionName: string;
    contentType?: string | false;
    processData?: boolean;
    csrfToken?: string;
    parameter: object | string;
    loadingTarget?: string;
    responseType?: XMLHttpRequestResponseType;
    callbackSuccess?: dbh_lib.CallbackFunctions;
    callbackError?: dbh_lib.CallbackFunctions;
}